module.exports = __webpack_public_path__ + "media/images/firewood-legacy-badge-1ceee0ee871ea3626cc8dceb69d395d7.png";